import { AmenityPricingMode } from '@yawi/types';
import type { Amenity } from '@yawi/types';

export interface AmenityPricing {
  pricingMode: AmenityPricingMode;
  price: number;
  depositAmount: number;
}

type PricedAmenity = Pick<Amenity, 'costPerHour' | 'requiresDeposit' | 'depositAmount' | 'pricingMode' | 'sectionPrices'>;

/**
 * Precio que aplica a una unidad: el de su sección si la amenidad lo define,
 * o el base. Misma regla que el backend (`amenity-pricing.util.ts`).
 */
export function resolveAmenityPricing(
  amenity: PricedAmenity,
  sectionId: string | null | undefined
): AmenityPricing {
  const baseDeposit = amenity.requiresDeposit ? Number(amenity.depositAmount ?? 0) : 0;
  const override = sectionId ? amenity.sectionPrices?.find((p) => p.sectionId === sectionId) : undefined;
  if (override) {
    return {
      pricingMode: override.pricingMode,
      price: Number(override.price),
      depositAmount: override.depositAmount === null ? baseDeposit : Number(override.depositAmount),
    };
  }
  return {
    pricingMode: amenity.pricingMode ?? AmenityPricingMode.PER_HOUR,
    price: Number(amenity.costPerHour),
    depositAmount: baseDeposit,
  };
}

/** Costo de renta (sin depósito): total fijo, o precio por hora × horas. */
export function amenityRentalCost(pricing: AmenityPricing, hours: number): number {
  return pricing.pricingMode === AmenityPricingMode.FLAT ? pricing.price : pricing.price * hours;
}
